import AuthResetPassword from './ResetPassword';

export default AuthResetPassword;
